import React from 'react';
import EcoTabImgs, { EcoTabImgsItem } from 'eco-design/sections-test/eco-tab-imgs';
import EcoSpace from 'eco-design/base/eco-space';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

const TabImgs: React.FC = () => {
    const { t } = useLang('theProduct.TabImgs');
    const { locale } = getLocal();

    const IS_EU = ['eu', 'uk', 'de', 'fr', 'es', 'it'].includes(locale);
    const IS_NA = ['us', 'ca'].includes(locale);

    const items: EcoTabImgsItem[] = [
        {
            tabLabel: t('tab1'),
            tabValue: '0',
            imgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748661210829/1-1.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1748661210829/1-1.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1748661209725/1-1-h5.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748661211601/1-2.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1748661211601/1-2.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1748661209957/1-2-h5.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748661211054/1-3.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1748661211054/1-3.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1748661211221/1-3-h5.jpg',
                },
            ],
        },
        {
            tabLabel: t('tab2'),
            tabValue: '1',
            imgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748661210290/2-1.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1748661210290/2-1.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1748661210471/2-1-h5.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748661211408/2-2.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1748661211408/2-2.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1748661211770/2-2-h5.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748661210100/2-3.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1748661210100/2-3.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1748661210648/2-3-h5.jpg',
                },
            ],
        },
    ];

    const EU_Items: EcoTabImgsItem[] = [
        {
            tabLabel: t('tab1'),
            tabValue: '0',
            imgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312230397/1-1.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312230397/1-1.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312227813/1-1-h5.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312229400/1-2.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312229400/1-2.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312231680/1-2-h5.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312228995/1-3.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312228995/1-3.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312228744/1-3-h5.jpg',
                },
            ],
        },
        {
            tabLabel: t('tab2'),
            tabValue: '1',
            imgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312228281/2-1.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312228281/2-1.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312231921/2-1-h5.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312230807/2-2.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312230807/2-2.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312229646/2-2-h5.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312229977/2-3.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312229977/2-3.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312231149/2-3-h5.jpg',
                },
            ],
        },
    ];

    const NA_Items: EcoTabImgsItem[] = [
        {
            tabLabel: t('tab1'),
            tabValue: '0',
            imgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312229400/1-2.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312229400/1-2.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312231680/1-2-h5.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312230397/1-1.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312230397/1-1.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312227813/1-1-h5.jpg',
                },

                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312228995/1-3.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312228995/1-3.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312228744/1-3-h5.jpg',
                },
            ],
        },
        {
            tabLabel: t('tab2'),
            tabValue: '1',
            imgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312230807/2-2.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312230807/2-2.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312229646/2-2-h5.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312228281/2-1.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312228281/2-1.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312231921/2-1-h5.jpg',
                },

                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312229977/2-3.jpg',
                    pad: 'https://websiteoss.ecoflow.com/upload/image/1750312229977/2-3.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312231149/2-3-h5.jpg',
                },
            ],
        },
    ];

    return (
        <>
            <EcoSpace />
            <EcoTabImgs className={css.comp} title={t('title')} items={IS_NA ? NA_Items : IS_EU ? EU_Items : items} />
        </>
    );
};
export default TabImgs;
